import { BaseService } from '@usercentrics/cmp-browser-sdk';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { COOKIE_CONSENT_ACTIONS, COOKIE_CONSENT_STORE_NAME } from './use-cookie-consent-store.constants';

type CookieConsentState = {
    services: BaseService[];
};

type CookieConsentActions = {
    reset: () => void;
    setServices: (services: BaseService[]) => void;
};

export type CookieConsentStore = CookieConsentState & CookieConsentActions;

const initialState: CookieConsentState = {
    services: []
};

export const useCookieConsentStore = create<CookieConsentStore>()(
    devtools(
        (set) => ({
            ...initialState,
            setServices: (services) => set({ services }, false, COOKIE_CONSENT_ACTIONS.SET_SERVICES),
            reset: () => set(initialState, false, COOKIE_CONSENT_ACTIONS.RESET)
        }),
        { name: COOKIE_CONSENT_STORE_NAME }
    )
);
